import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Card, Skeleton } from '@heroui/react';
import { PageLayout } from '@/shared/ui';

/**
 * Экран, пока грузится чанк страницы (`lazyPage` в `app/router`): шапка,
 * вступление и тот же скелет списка, что `MemoryPage` показывает, пока ждёт
 * факты. Поле ввода — серая плашка его высоты: настоящее поле — это уже код
 * страницы.
 */
export function MemoryPageSkeleton() {
  const { t } = useTranslation('MemoryPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('title')} onBack={() => void navigate(-1)}>
      <p className="text-sm leading-relaxed text-ink-muted">{t('intro')}</p>
      {/* Поле HeroUI на мобильной ширине выше: там у него 16px шрифт (иначе iOS зумит при фокусе). */}
      <Skeleton className="h-10 rounded-xl md:h-9" />
      <MemorySkeleton label={t('loading')} />
    </PageLayout>
  );
}

const SKELETON_WIDTHS = ['w-48', 'w-36', 'w-56'];

export function MemorySkeleton({ label }: { label: string }) {
  return (
    <div className="flex flex-col gap-2" aria-busy="true" aria-live="polite">
      <span className="sr-only">{label}</span>
      <Card className="divide-y divide-hairline gap-0 overflow-hidden p-0">
        {SKELETON_WIDTHS.map((width) => (
          <div key={width} className="flex items-center px-4 py-3">
            <Skeleton className={`h-4 ${width} rounded-md`} />
          </div>
        ))}
      </Card>
    </div>
  );
}
